import { useMutation } from "@apollo/client/react";
import { UPDATE_OVERVIEW } from "../../mutations/invoiceInterpretationTemplates/updateOverview";
import type { TemplateOverviewInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateOverview = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_OVERVIEW,
    { onCompleted, onError },
  );

  const updateOverview = async ({
    input,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    input: TemplateOverviewInput;
  }) => {
    return mutation({
      variables: { templateId, clientIdentifier, input },
    });
  };

  return { updateOverview, loading, error, data };
};
